// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  workspaceId: __t.u64(),
  subjectKind: __t.string(),
  subjectId: __t.u64(),
  key: __t.string(),
  valueJson: __t.string(),
  source: __t.string(),
  triggeredByMessageId: __t.u64(),
};
